import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { ClientId, FartherAccountId } from "../../Types";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import ValidationError from "../../ZodError";
import { TaxBudgetSchemaResponse } from "../types";
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/investment/tax/tax-budget"
    : "https://middleware.uat.farther.com/investment/tax/tax-budget";
export const PostTaxBudgetRequestSchema = z.object({
    budgetAmount: z.number(),
    clientIds: z.array(ClientId),
    excludedVirtualAccountIds: z.array(FartherAccountId),
    year: z.number(),
});
export const PostTaxBudgetResponseSchema = z.object({
    data: TaxBudgetSchemaResponse,
});
export default async function postTaxBudget(request, config) {
    const { data } = await axios.post(url(), PostTaxBudgetRequestSchema.parse(request), {
        headers: {
            "idempotency-key": genIdempotencyKey(`postTaxBudget-clientId-${request.clientIds[0]}-year-${request.year}-budgetAmount-${request.budgetAmount}`),
            version: "20250318",
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = PostTaxBudgetResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[postTaxBudget] returned unexpected data.";
        errorLog(postTaxBudget.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postTaxBudget.js.map